var map = {
	"./بابايا.png": "fe0b",
	"./بطيخ.png": "3183",
	"./تفاح.png": "bcce",
	"./تمر.png": "67e0",
	"./توت.png": "38ad",
	"./تين.png": "c1bf",
	"./جوافة.png": "ac20",
	"./حمضيات.png": "83bb",
	"./خوخ.png": "d8a0",
	"./رمان.png": "e707",
	"./زيتون.png": "1dfd",
	"./سدر.png": "6cd1",
	"./شمام.png": "88b2",
	"./عنب.png": "e36d",
	"./لوز.png": "a0ac",
	"./مانغو.png": "bd57",
	"./موز.png": "7c1a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "576c";